import cx from 'classnames';
import s from './styles.scss';
import { Size, Icons, ColorHue, ColorTheme } from '../../enums';

export interface IconProps {
  className?: string;
  name: Icons;
  size?: Size;
  color?: ColorHue | ColorTheme;
}

export const Icon = ({
  className,
  name,
  size = Size.MEDIUM,
  color,
}: IconProps): JSX.Element => {
  return (
    <svg
      className={cx(s.icon, s[size], color && s[color], className)}
      role="img"
    >
      <use href={`#${name}`} />
    </svg>
  );
};
